import * as ActionTypes from "./ActionTypes";
import {ApiManager} from "../api/ApiManager";
import PatientVital from "../models/IPatientVital"
import IMedicine from "../models/IMedicine";

// TYPEAHEAD ACTIONS

export class MedicationActions {
    /* thunk functions  */
    static loadMedicines = function (name: string) {
        return ApiManager.getAlbusApis().getMedicineByName(name);
    }

    static loadMedicinesByGenericName = function (name: string) {
        return ApiManager.getAlbusApis().getMedicineByMolecule(name);
    }

    static loadSymptoms = function(name: string) {
        return ApiManager.getAlbusApis().getSymptomsByName(name);
    }

    static loadDiseases = function(name: string) {
        return ApiManager.getAlbusApis().getDiseaseByName(name);
    }

    static loadAllergies = function(allergen: string) {
        return ApiManager.getAlbusApis().getAllergiesByName(allergen);
    }
}
